import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './ListingPriorities.css';

// Query
import listingPrioritiesQuery from './listingPrioritiesQuery.graphql';
import { withQuery } from '../../../hoc/withGraphql';

// Component
import ListingPrioritiesManagement from '../../../components/siteadmin/ListingPrioritiesManagement';
import Loader from '../../../components/Loader';

class ListingPriorities extends React.Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
    getListingsForPriority: PropTypes.shape({
      loading: PropTypes.bool,
      getListingsForPriority: PropTypes.object,
    })
  };

  static defaultProps = {
    getListingsForPriority: {
      loading: true
    }
  };

  render() {
    const { getListingsForPriority: { loading, getListingsForPriority, refetch } } = this.props;
    if (loading) {
      return <Loader type={"text"} />;
    } else {
      return <ListingPrioritiesManagement
        data={getListingsForPriority}
        refetch={refetch}
      />;
    }
  }

}

export default compose(
  withStyles(s),
  withQuery(listingPrioritiesQuery, {
    name: 'getListingsForPriority',
    options: {
      variables: {
        currentPage: 1,
        searchList: ''
      },
      fetchPolicy: 'network-only',
      ssr: false
    }
  }),
)(ListingPriorities);
